export default __webpack_public_path__ + "static/media/55.0f44dfa5.jpg";